/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: branding-container-edit-view-component.ts
 *
 * Created by rwilliams on 8/6/17,
 * Refactored by kyang on 10/15/20.
 */

//
// Notes:
//
// * A branding asset is any of: a preroll, a postroll, a visual
//   watermark, artwork, or a "break pre/post roll".
//
// * Branding assets are aggregated together in a named object
//   known as a "container". Contents and Networks may have zero
//   or more containers for each type of branding asset.
//
// * Series containers can be overridden by season- or
//   volume-specific containers; these appear in the branding
//   asset search view as child containers and appear under the
//   name of the season or volume to which they apply.
//
// * An asset object encapsulates a particular branding asset or,
//   in the case of "break pre/post rolls", encapsulates both the
//   break preroll and break postroll.
//
// * Each container has at most one asset object per relevant MAP.
//
// * Relevant MAPs consist of all VIDEO MAPs in the system, except
//   in the case of artwork, in which case they consist of all
//   MAPs of type "OTHER" (not of type "IMAGE" as you might
//   expect).
//
// * Season or volume specific assets will have a seasonId or a
//   volumeId, respectively.
//

function BrandingContainerEditViewController(
    this: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    BrandingContainerEditService: JS5Object,
    BrandingViewService: JS5Object,
    BreadcrumbService: JS5Object,
) {

    this.getBreadcrumbName = () => {
        return _.get(BrandingContainerEditService, 'originalEditData.name', `New ${this.brandingConfig.type}`);
    };

    this.editingNewBrandingAssetContainer = () => {
        return $routeParams.containerId === '-1';
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        BrandingViewService.initializeParentBreadcrumbs(this.brandingConfig, $route.current.params);
    }

    this.$onDestroy = () => {
        BreadcrumbService.clearBreadcrumbs();
    };
}

angular
    .module('prism-ui.components.branding')
    .component('brandingContainerEditView', {
        templateUrl: 'components/branding/editView/branding-container-edit-view-template.html',
        controller: BrandingContainerEditViewController,
        bindings: {
            brandingConfig: '<'
        }
    });
